import { __assign, __rest } from "tslib";
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import Overlay from '../overlay';
import { useLazyRender } from '../hooks/use-lazy-render';
import '../overlay/style/index';
var Popup = function (_a, ref) {
    var _b = _a.prefixCls, prefixCls = _b === void 0 ? 'pptmui-popup' : _b, _c = _a.duration, duration = _c === void 0 ? 300 : _c, _d = _a.overlay, overlay = _d === void 0 ? true : _d, _e = _a.overlayCloseable, overlayCloseable = _e === void 0 ? true : _e, position = _a.position, visible = _a.visible, className = _a.className, overlayClassName = _a.overlayClassName, overlayStyle = _a.overlayStyle, onClose = _a.onClose, transitionName = _a.transitionName, style = _a.style, onOverlayClick = _a.onOverlayClick, round = _a.round, children = _a.children, otherProps = __rest(_a, ["prefixCls", "duration", "overlay", "overlayCloseable", "position", "visible", "className", "overlayClassName", "overlayStyle", "onClose", "transitionName", "style", "onOverlayClick", "round", "children"]);
    var _f = React.useState(), popupStyle = _f[0], setPopupStyle = _f[1];
    var preVisibleProp = React.useRef();
    var lazyRender = useLazyRender(visible);
    React.useEffect(function () {
        var elStyle = {};
        if (!preVisibleProp.current && visible) {
            var key = position === 'center' ? 'animationDuration' : 'transitionDuration';
            elStyle[key] = duration + "ms";
            setPopupStyle(elStyle);
        }
        else if (preVisibleProp.current && !visible) {
            elStyle.display = 'none';
            setPopupStyle(elStyle);
        }
        preVisibleProp.current = visible;
    }, [duration, visible, position]);
    var handleOverlayClick = React.useCallback(function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (overlayCloseable && onClose) {
            onClose();
        }
        if (onOverlayClick) {
            onOverlayClick(e);
        }
    }, [onOverlayClick, overlayCloseable, onClose]);
    var renderOverlay = function () {
        if (!overlay) {
            return null;
        }
        return (React.createElement(Overlay, { visible: visible, className: overlayClassName, style: overlayStyle, onClick: handleOverlayClick }));
    };
    var renderPopupChildren = lazyRender(function () {
        return React.createElement(React.Fragment, null, children);
    });
    var renderTransition = function () {
        var _a;
        var name = position === 'center' ? "pptmui-fade" : prefixCls + "-slide-" + position;
        var popupCls = classNames(prefixCls, className, position && prefixCls + "--" + position, (_a = {},
            _a[prefixCls + "--visible"] = visible,
            _a[prefixCls + "--round"] = round,
            _a));
        var combineStyle = __assign(__assign({}, popupStyle), style);
        return (React.createElement(CSSTransition, { classNames: transitionName || name, in: visible, timeout: 300, unmountOnExit: true },
            React.createElement("div", __assign({ className: popupCls, ref: ref, style: combineStyle }, otherProps), renderPopupChildren())));
    };
    return (React.createElement(React.Fragment, null,
        renderOverlay(),
        renderTransition()));
};
export default React.forwardRef(Popup);
